<template>
  <div class="sidebar" :class="{ 'sidebar--closed': !isSideBarOpen }">
    <div class="sidebar-content">
      <div class="sidebar-content__logo cursor-pointer">
        <router-link
          v-if="getBnplInstanceType === BNPL_INSTANCE_TYPE.FACTORING"
          tag="img"
          class="cursor-pointer"
          :src="require('@/assets/images/milpay-logo.svg')"
          to="/profile"
        />
        <router-link
          v-else-if="
            getBnplInstanceType === BNPL_INSTANCE_TYPE.MERCHANT_FINANCE
          "
          tag="img"
          class="cursor-pointer"
          :src="require('@/assets/images/instacash-inner-logo.svg')"
          to="/profile"
        />
        <b-skeleton v-else width="160" height="48" position="is-centered" />
      </div>
      <!--      :src="require('@/assets/images/instacash-inner-logo.svg')"-->

      <menu-content></menu-content>

      <div
        @click="isSideBarOpen = !isSideBarOpen"
        class="sidebar-toggle"
        :class="{ 'sidebar-toggle--closed': !isSideBarOpen }"
      >
        <b-icon icon="chevron-left" type="is-white" size="is-small"> </b-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { BNPL_INSTANCE_TYPE } from "@/utils/const";
export default {
  name: "SideBar",
  data() {
    return {
      isSideBarOpen: true,
      BNPL_INSTANCE_TYPE,
    };
  },
  components: {
    MenuContent: () => import("./MenuContent.vue"),
  },
  computed: {
    ...mapGetters({
      getBnplInstanceType: "uiConfigStore/getBnplInstanceType",
    }),
  },
  methods: {
    ...mapActions({}),
  },
};
</script>

<style scoped lang="scss">
.sidebar-content__logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 768px) {
  .sidebar {
    display: none;
  }
}
</style>
